import { memo } from 'react';
import './ImageBanner.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

/* External */
function ImageBanner(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    backgroundImageUrl = _ref.backgroundImageUrl,
    imageUrl = _ref.imageUrl,
    _ref$headline = _ref.headline,
    headline = _ref$headline === void 0 ? '' : _ref$headline,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    children = _ref.children;
  return /*#__PURE__*/jsxs("div", {
    className: "dtv-common-c-image-banner ".concat(className),
    children: [/*#__PURE__*/jsx("img", {
      className: "dtv-common-c-image-banner__background-image",
      src: backgroundImageUrl,
      alt: title
    }), /*#__PURE__*/jsxs("div", {
      className: "dtv-common-c-image-banner__text-container",
      children: [/*#__PURE__*/jsx("img", {
        className: "dtv-common-c-image-banner__image",
        src: imageUrl,
        alt: subtitle
      }), /*#__PURE__*/jsx("h3", {
        className: "dtv-common-c-image-banner__headline",
        children: headline
      }), /*#__PURE__*/jsx("h3", {
        className: "dtv-common-c-image-banner__title",
        children: title
      }), /*#__PURE__*/jsx("h4", {
        className: "dtv-common-c-image-banner__subtitle",
        children: subtitle
      }), children]
    })]
  });
}
var ImageBanner$1 = /*#__PURE__*/memo(ImageBanner);

export { ImageBanner$1 as default };
//# sourceMappingURL=ImageBanner.js.map
